module.exports = __webpack_public_path__ + "img/new-logo.79181807.svg";